import { render, staticRenderFns } from "./shopForm.vue?vue&type=template&id=523d6231"
import script from "./shopForm.vue?vue&type=script&lang=js"
export * from "./shopForm.vue?vue&type=script&lang=js"
import style0 from "./shopForm.vue?vue&type=style&index=0&id=523d6231&prod&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports